import { Divider } from "@mui/material";
import { twMerge } from "tailwind-merge";

const CommonDivider = ({ className }: { className?: string }) => {
	const classes = twMerge("border ml-0 !my-[32px]", className);
	return <Divider className={classes} variant="middle" />;
};

export default CommonDivider;
